﻿module.exports = {
	ain: 'ᴥ',
	airplane: '✈️',
	alarm: '⏰',
	alien: '👽',
	anchor: '⚓',
	ant: '🐜',
	apple: '🍎',
	appleGreen: '🍏',
	appleRed: '🍎',
	aquarius: '♒',
	aries: '♈',
	arrowW: '←',
	arrowL: '←',
	arrowNW: '↖',
	arrowN: '↑',
	arrowU: '↑',
	arrowNE: '↗',
	arrowE: '→',
	arrowR: '→',
	arrowSE: '↘',
	arrowS: '↓',
	arrowD: '↓',
	arrowSW: '↙',
	arrowTriD: '▼',
	arrowTriL: '◀',
	arrowTriR: '▶',
	arrowTriU: '▲',
	arrowTriDoubleD: '⏬',
	arrowTriDoubleL: '⏪',
	arrowTriDoubleLEnd: '⏮',
	arrowTriDoubleR: '⏩',
	arrowTriDoubleREnd: '⏮',
	arrowTriDoubleU: '⏫',
	arrowTriSmD: '🔽',
	arrowTriSmU: '🔼',
	arrowCircleL: '↶',
	arrowCircleR: '↷',
	arrowCircleFull: '⟳',
	arrowDoubleL: '«',
	arrowDoubleR: '»',
	arrowRefresh: '↺',
	arrowCompassR: '➢',
	arrowCompassInvertedR: '➣',
	attachment: '📎',
	aubergine: '🍆',
	avocado: '🥑',
	balloon: '🎈',
	balloonSpeech: '💬',
	balloonThought: '💭',
	bank: '🏛',
	banknote: '💵',
	banknoteEuro: '💶',
	banknotePound: '💷',
	banknoteYen: '💴',
	banana: '🍌',
	bang: '💥',
	bat: '🦇',
	bearFace: '🐻',
	bee: '🐝',
	bell: '🔔',
	bellCancel: '🔕',
	bomb: '💣',
	book: '📕',
	books: '📚',
	bookBlue: '📘',
	bookGreen: '📗',
	bookOpen: '📖',
	bookOrange: '📙',
	bookRed: '📕',
	bookmark: '🔖',
	bookmarks: '📑',
	bird: '🐦',
	birthdayCake: '🎂',
	bread: '🍞',
	bride: '👰',
	bug: '🐛',
	bus: '🚍',
	butterfly: '🦋',
	burrito: '🌯',
	cactus: '🌵',
	cake: '🍰',
	calendar: '📅',
	calendarSpiral: '🗓',
	calendarTearOff: '📆',
	camel: '🐫',
	camelDromedary: '🐪',
	camelBactrian: '🐫',
	cancel: '✘',
	cancer: '♋',
	candle: '🕯',
	candy: '🍬',
	capricorn: '♑',
	car: '🚘',
	carouselHorse: '🎠',
	carrot: '🥕',
	castle: '🏰',
	cat: '🐈',
	catFace: '🐱',
	caterpillar: '🐛',
	chartBar: '📊',
	chartDown: '',
	chartUp: '📈',
	check: '√',
	checkHeavy: '✔️',
	checkHeavyWhite: '✅',
	checkBallot: '☑',
	checkeredFlag: '🏁',
	cheese: '🧀',
	cherry: '🍒',
	chessKingB: '♚',
	chessQueenB: '♛',
	chessRookB: '♜',
	chessBishopB: '♝',
	chessNightB: '♞',
	chessPawnB: '♟',
	chessKingW: '♔',
	chessQueenW: '♕',
	chessRookW: '♖',
	chessBishopW: '♗',
	chessNightW: '♘',
	chessPawnW: '♘',
	chestnut: '🌰',
	chick: '🐤',
	chickFront: '🐥',
	chicken: '🐔',
	chipmunk: '🐿',
	chocolate: '🍫',
	church: '⛪',
	city: '🏙',
	cityDusk: '🌆',
	citySunset: '🌇',
	circleBlackWhite: '◑',
	circus: '🎪',
	clover: '☘',
	clown: '🤡',
	cloud: '☁',
	clipboard: '📋',
	coffee: '☕',
	coffin: '⚰',
	comet: '☄',
	compression: '🗜',
	controlKnobs: '🎛',
	convenienceStore: '🏪',
	cookie: '🍪',
	copyright: '©',
	cowFace: '🐮',
	creditCard: '💳',
	crocodile: '🐊',
	cross: '×',
	crossHeavy: '✖️',
	crossedFlags: '🎌',
	crossedSwords: '⚔',
	crown: '♕',
	cucumber: '🥒',
	dagger: '🗡',
	deer: '🦌',
	departmentStore: '🏬',
	diamond: '💎',
	dog: '🐕',
	dogFace: '🐶',
	dolphin: '🐬',
	donut: '🍩',
	door: '🚪',
	dot: '•',
	dragon: '🐉',
	droplet: '💧',
	dress: '👗',
	drums: '🥁',
	duck: '🦆',
	dumpling: '🥟',
	eagle: '🦅',
	edit: '✎',
	egg: '🥚',
	eightball: '➑',
	elephant: '🐘',
	email: '📧',
	eye: '👁',
	eyeglasses: '👓',
	eyes: '👀',
	fax: '📠',
	female: '♀',
	females: '⚢',
	ferriswheel: '🎡',
	ferry: '⛴',
	filmCamera: '🎥',
	filmFrames: '🎞',
	filmProjector: '📽',
	fish: '🐟',
	fishTropical: '🐠',
	fishingPole: '🎣',
	fire: '🔥',
	fireworks: '🎆',
	flames: '🔥',
	flower: '⚘',
	flowers: '💐',
	flowerRose: '🌹',
	flowerSun: '🌻',
	flowerSymbol: '߷',
	flowerTulip: '🌷',
	forkKnife: '🍴',
	forkKnifePlate: '🍽',
	fountain: '⛲',
	fourLeafClover: '🍀',
	foxFace: '🦊',
	framedPicture: '🖼',
	fries: '🍟',
	frogFace: '🐸',
	gear: '⚙',
	gemini: '♊',
	ghost: '👻',
	gift: '🎁',
	globe: '🌎',
	globeAmerica: '🌎',
	globeAsiaAus: '🌏',
	globeEurAfr: '🌍',
	globeMeridians: '🌐',
	goat: '🐐',
	gorilla: '🦍',
	grapes: '🍇',
	groom: '🤵',
	guitar: '🎸',
	halloween: '🎃',
	hamburger: '🍔',
	hammer: '🔨',
	hammerPick: '⚒',
	hammerSickle: '☭',
	hammerWrench: '🛠',
	hamsterFace: '🐹',
	handVictory: '✌',
	handshake: '🤝',
	handwriting: '✍',
	hatching: '🐣',
	heart: '❤️',
	heartArrow: '💘',
	heartBeating: '💓',
	heartBlue: '💙',
	heartBroken: '💔',
	heartDeco: '💟',
	heartFlower: '❦',
	heartFlowerL: '❧',
	heartFlowerR: '☙',
	heartGreen: '💚',
	heartGrowing: '💗',
	heartLight: '♥',
	heartManMan: '👨‍❤️‍👨',
	heartPurple: '💜',
	heartRibbon: '💝',
	heartSmile: '😍',
	heartSparkling: '💖',
	heartUpsideDown: 'ᜊ',
	heartWomanWoman: '👩‍❤️‍👩',
	heartYellow: '💛',
	hearts: '💕',
	heartsRevolving: '💞',
	herb: '🌿',
	hole: '🕳',
	home: '🏠',
	homes: '🏘',
	homeGarden: '🏡',
	honey: '🍯',
	horn: '📯',
	horse: '🐎',
	horseFace: '🐴',
	horseRacing: '🏇',
	hot: '🔥',
	hotdog: '🌭',
	hotPepper: '🌶',
	hotel: '🏨',
	hotsprings: '♨',
	hourglass: '⌛',
	hourglassRunning: '⏳',
	iceCream: '🍨',
	iceCreamSoft: '🍦',
	iceSkate: '⛸',
	jeans: '👖',
	joystick: '🕹',
	joypad: '🎮',
	key: '🔑',
	keyOld: '🗝',
	keyboard: '⌨',
	kiwi: '🥝',
	koala: '🐨',
	label: '🏷',
	ladybird: '🐞',
	leaf: '🍂',
	leafMaple: '🍁',
	leafWind: '🍃',
	lemon: '🍋',
	leo: '♌',
	leopard: '🐆',
	levelSlider: '🎚',
	libra: '♎',
	link: '🔗',
	lionFace: '🦁',
	lizard: '🦎',
	lock: '🔒',
	lockClosed: '🔒',
	lockClosedWithKey: '🔐',
	lockOpen: '🔓',
	love: '💕',
	loveCouple: '💑',
	loveLetter: '💌',
	loveHotel: '🏩',
	mail: '✉',
	male: '♂',
	males: '⚣',
	man: '👨',
	mansShoe: '👞',
	melon: '🍈',
	menu: '☰',
	magnifyingGlass: '🔍',
	map: '🗺',
	memo: '📝',
	microphone: '🎙',
	mobilePhone: '📱',
	monkey: '🐒',
	monkeyFace: '🐵',
	monkeyNoEvilHear: '🙉',
	monkeyNoEvilSee: '🙈',
	monkeyNoEvilSpeak: '🙊',
	moon: '○',
	moonNew: '●',
	moonFirst: '◐',
	moonFull: '○',
	moonThird: '◑',
	mosque: '🕌',
	motorboat: '🛥',
	mountain: '⛰',
	mountFuji: '🗻',
	mouse: '🐁',
	mouseFace: '🐭',
	mushroom: '🍄',
	music: '🎶',
	musicalKeyboard: '🎹',
	musicalNote: '♪',
	musicalNoteDouble: '♫',
	nameBadge: '📛',
	neckTie: '👔',
	newspaper: '📰',
	noEntry: '🚫',
	noEntryUnder18: '🔞',
	nut: '🌰',
	nutAndBolt: '🔩',
	octopus: '🐙',
	office: '🏢',
	ohm: 'Ω',
	ok: '✔',
	oneHalf: '½',
	oneThird: '⅓',
	oneFourth: '¼',
	oneFifth: '⅕',
	oneSixth: '⅙',
	oneSeventh: '⅐',
	oneEight: '⅛',
	ophiuchus: '⛎',
	owl: '🦉',
	pageCurl: '📃',
	pancakes: '🥞',
	pandaFace: '🐼',
	paperclip: '📎',
	pause: '⏸',
	peace: '☮',
	peaceDove: '🕊',
	peach: '🍑',
	pear: '🍐',
	pencil: '✎',
	penguin: '🐧',
	phone: '☎',
	phoneWhite: '☏',
	pick: '⛏',
	pig: '🐖',
	pigFace: '🐷',
	pigNose: '🐽',
	pileOfPoo: '💩',
	pill: '💊',
	pin: '📌',
	pinRound: '📍',
	pineapple: '🍍',
	pisces: '♓',
	pistol: '🔫',
	play: '⏵',
	plus: '✚',
	pointL: '☚',
	pointR: '☛',
	pointU: '☝',
	pointD: '☟',
	popcorn: '🍿',
	potato: '🥔',
	prayerBeads: '📿',
	pregnant: '🤰',
	priceTag: '🏷',
	printer: '🖨',
	question: '❓',
	rabbit: '🐇',
	rabbitFace: '🐰',
	radio: '📻',
	rainbow: '🌈',
	rat: '🐀',
	record: '⏺',
	recycling: '♻',
	registered: '®',
	rhinocerus: '🦏',
	ribbon: '🎀',
	ring: '💍',
	rooster: '🐓',
	rollercoaster: '🎢',
	ruler: '📏',
	rulerTriangular: '📐',
	sagittarius: '♐',
	sailboat: '⛵',
	satellite: '🛰',
	satelliteAntenna: '📡',
	saxophone: '🎷',
	scales: '⚖',
	scorpius: '♏',
	school: '🏫',
	scissors: '✂',
	scroll: '📜',
	seedling: '🌱',
	shamrock: '☘',
	shark: '🦈',
	sheep: '🐑',
	shield: '🛡',
	ship: '🚢',
	shipPassengers: '🛳',
	shirt: '👕',
	shoppingBags: '🛍',
	shoppingTrolley: '🛒',
	shrimp: '🦐',
	skull: '💀',
	skullAndBones: '☠',
	smile: '☺',
	smoking: '🚬',
	smokingForbidden: '🚭',
	snail: '🐌',
	snake: '🐍',
	snow: '❆',
	snowman: '☃',
	snowmanWithoutSnow: '⛄',
	snowCappedMountain: '🏔',
	spaghetti: '🍝',
	speaker: '🔈',
	speakerCancel: '🔇',
	speakerSound: '🔉',
	speakerSoundLoud: '🔊',
	speedboat: '🚤',
	spider: '🕷',
	spiderWeb: '🕸',
	spoon: '🥄',
	squid: '🦑',
	star: '★',
	starOpen: '☆',
	starBorder: '✭',
	starCircle: '✪',
	starCircleSmall: '⍟',
	starCrescent: '☪',
	starDavid: '✡',
	starScience: '⚝',
	starTopo: '❉',
	starDeco: '❋',
	starDeco2: '✺',
	starDeco3: '✹',
	starFalling: '🌠',
	starShining: '🌟',
	star3D: '✰',
	stop: '⏹',
	stopwatch: '⏱',
	strawberry: '🍓',
	suitClubs: '♣',
	suitDiamonds: '♦',
	suitHearts: '♥',
	suitSpades: '♠',
	sun: '☀',
	sunglasses: '🕶',
	sunrise: '🌅',
	sunriseMountain: '🌄',
	sunriseCity: '🌇',
	sushi: '🍣',
	synagogue: '🕍',
	taco: '🌮',
	tangerine: '🍊',
	taurus: '♉',
	telephone: '☎️',
	telephoneReceiver: '📞',
	television: '📺',
	thermometer: '🌡',
	ticket: '🎫',
	ticketAdmission: '🎟',
	tigerFace: '🐯',
	tomato: '🍅',
	topHat: '🎩',
	tractor: '🚜',
	trademark: '™',
	tree: '🌳',
	treeChristmas: '🎄',
	treePalm: '🌴',
	treePine: '🌲',
	treeTanabata: '🎋',
	tricolon: '⁝',
	trumpet: '🎺',
	turkey: '🦃',
	turtle: '🐢',
	umbrella: '☂',
	umbrellaRain: '☔',
	unicorn: '🦄',
	video: '',
	videoCamera: '📹',
	videoCassette: '📼',
	videoGame: '🎮',
	violin: '🎻',
	virgo: '♍',
	vulcano: '🌋',
	warning: '⚠️',
	wastebasket: '🗑',
	watch: '⌚',
	watermelon: '🍉',
	waterWave: '🌊',
	wedding: '💒',
	whale: '🐋',
	wheelchair: '♿',
	wolfFace: '🐺',
	woman: '👩',
	womansHat: '👒',
	womansClothes: '👚',
	womansBoots: '👢',
	womansShoes: '👠',
	wrench: '🔧',
	yinyang: '☯',
}
